import { ViewController } from 'ionic-angular';

import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from './../dashboard/dashboard';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-changepassword',
  templateUrl: 'changepassword.html',
})
export class ChangePassword extends Util {

  params = { id: '', oldPassword: '', newPassword: '' };
  rippasswordnew = '';
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, public viewctrl: ViewController, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);

    // this.storage.get('user').then((userdata) => {
    this.GetRequest('me', '', true, false).then((userdata) => {
      // console.log(userdata);
      for (let key in this.params) {
        this.params[key] = userdata['user'][key];
      }
    })

  }

  back() {
    this.viewctrl.dismiss();
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  salva() {
    this.translate.get(['recuperapassword.PASSMODIFICATA','recuperapassword.PASSMODIFICATASUCC','ERRORE','recuperapassword.ERRPASS']).subscribe(v => {
      if (this.params.newPassword == this.rippasswordnew) {
        this.PutRequest('password', this.params.id, this.params).then((res) => {
          // console.log(res);
          this.showBasicAlert(v['recuperapassword.PASSMODIFICATA'], v['recuperapassword.PASSMODIFICATASUCC']);
          this.viewctrl.dismiss();

        }).catch((e) => {
          //this.navCtrl.push(Mj_Detail,{mj:m});
          console.error(e)
        })
      }
      else
        this.showBasicAlert(v['ERRORE'], v['recuperapassword.ERRPASS']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/changepassword/changepassword.ts